export function checkAndHideZeroReviewElements() {
  const reviewWidgets = document.querySelectorAll('.yotpo-widget-instance[data-yotpo-widget-uuid]:not([data-review-check-complete]');

  reviewWidgets.forEach(reviewWidget => {
    const reviewElement = reviewWidget.querySelector('.yotpo-sr-bottom-line-text.yotpo-sr-bottom-line-text--right-panel');

    if (!reviewElement) return;
    const reviewText = reviewElement.textContent.trim();

    // Mark this widget as checked to prevent future runs
    reviewWidget.setAttribute('data-review-check-complete', 'true');

    if (reviewText === '0 Reviews') {
      reviewWidget.remove();
    }
  });
}




// WEBPACK FOOTER //
// ./src/scripts/entry-points/plp/utils.js